import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LastSearchService {

  private isGoBack = false;

  get getSearchBack(): boolean {
    return this.isGoBack;
  }

  setSearchBack(isBack: boolean): boolean {
    return this.isGoBack = isBack;
  }
}
